import Locale from "locale";

export const getMaxErrorValidation = (max: number) =>
  [max, Locale.errors.max.replace("{}", max.toString())] as [number, string];

export const getMinErrorValidation = (max: number) =>
  [max, Locale.errors.min.replace("{}", max.toString())] as [number, string];

export const getZipCodeErrorValidation = () =>
  [9, Locale.errors.address.zipCode] as [number, string];
